<template>
  <div>
    <rich-text-editor v-model="comment.message" class="mb-2" />
    <div v-if="showTools" class="d-md-flex mb-2">
      <b-form-group v-if="showRoles" class="mb-2 mb-md-0">
        <template #label>
          <BIconEye aria-hidden="true" variant="primary" />
          {{ $t('comments.visible-for') }}:
        </template>
        <b-form-checkbox-group
          v-model="comment.visible_for_roles"
          :options="availableRoles"
          class="text-capitalize mr-n3"
        />
      </b-form-group>
      <template v-if="canMarkForProtocol">
        <div
          v-if="showRoles"
          class="d-none d-md-block ml-3 pl-3 border-left"
          aria-hidden="true"
        ></div>
      </template>
      <template v-if="canTakeActions">
        <div
          v-if="showRoles || canMarkForProtocol"
          class="d-none d-md-block ml-3 pl-3 border-left"
          aria-hidden="true"
        ></div>
        <div class="mb-2 mb-md-0">
          <b-form-group class="mb-0">
            <template #label>
              <BIconPatchCheck aria-hidden="true" variant="primary" />
              {{ $t('comments.action-taken') }}:
            </template>
            <b-form-checkbox inline v-model="comment.took_action" class="mr-2">
              Took action
            </b-form-checkbox>
            <template v-if="comment.took_action">
              <span class="text-muted mr-2">by</span>
              <b-form-radio-group
                class="d-inline"
                v-model="comment.action_type"
                :options="actionOptions"
              />
            </template>
          </b-form-group>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { BIconEye, BIconFileEarmarkText, BIconPatchCheck } from 'bootstrap-vue';
import BaseInput from './mixins/BaseInput';
import RichTextEditor from '../RichTextEditor';
import { UserRoleEnum } from '@gid/models';
import { CommentActionTypeEnum } from '@gid/models/dist/entities/comment';

export default {
  mixins: [BaseInput],
  components: {
    BIconEye,
    BIconPatchCheck,
    RichTextEditor,
  },
  props: {
    boundValue: Object,
    hideActions: Boolean,
    hideRoles: Boolean,
  },
  data() {
    return {
      comment: {
        message: null,
        visible_for_roles: [],
        action_type: CommentActionTypeEnum.GENERIC,
        took_action: false,
      },
      actionOptions: [
        { text: this.$t('comments.email'), value: CommentActionTypeEnum.EMAIL },
        { text: this.$t('comments.phone'), value: CommentActionTypeEnum.PHONE },
        {
          text: this.$t('comments.forwarded'),
          value: CommentActionTypeEnum.FORWARDED,
        },
      ],
    };
  },
  computed: {
    availableRoles() {
      const roles = [];
      if (this.$store.state.auth.user?.role == UserRoleEnum.ADMIN) {
        roles.push({
          value: UserRoleEnum.PARTNER,
          text: UserRoleEnum.PARTNER,
        });
        roles.push(UserRoleEnum.BRAND);
      }
      return roles;
    },
    canMarkForProtocol() {
      return [UserRoleEnum.ADMIN, UserRoleEnum.PARTNER].includes(
        this.$store.state.auth.user?.role,
      );
    },
    canTakeActions() {
      if (this.hideActions) {
        return false;
      }
      return UserRoleEnum.ADMIN == this.$store.state.auth.user?.role;
    },
    showRoles() {
      return !this.hideRoles && this.availableRoles.length > 1;
    },
    showTools() {
      return (
        this.availableRoles.length > 1 ||
        this.canMarkForProtocol ||
        this.canTakeActions
      );
    },
  },
  watch: {
    boundValue(newValue, oldValue) {
      const newSerialized = JSON.stringify(newValue);
      const oldSerialized = JSON.stringify(oldValue);
      if (newSerialized != oldSerialized) {
        this.comment = JSON.parse(newSerialized);
      }
    },
    'comment.took_action': function (value) {
      if (!value) {
        this.comment.action_type = CommentActionTypeEnum.GENERIC;
      }
    },
    comment: {
      deep: true,
      handler(comment) {
        this.commitOrEmit(comment);
      },
    },
  },
  created() {
    if (this.boundValue) {
      this.comment = JSON.parse(JSON.stringify(this.boundValue));
      if (
        this.comment.action_type &&
        this.comment.action_type != CommentActionTypeEnum.GENERIC
      ) {
        this.comment.took_action = true;
      }
    }
  },
};
</script>
